import { useGetConstantsQuery } from '@/services';
import { Constants } from '@/utils/enums';

function useConstant(constant: keyof typeof Constants) {
  const { data: constants } = useGetConstantsQuery({ params: { code: constant.toLowerCase() } });
  return constants?.data[0] ?? { value: '' };
}

export default useConstant;
